module.exports = __webpack_public_path__ + "img/BYPPAY-11.48bc5553.png";